import { FILTER_SEARCH_MIN_ITEMS } from "@lib/constants/filtersConstants";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { useMemo, useState } from "react";

type UseSearchableFilterOptionsResult = {
    searchQuery: string;
    setSearchQuery: (value: string) => void;
    isSearchable: boolean;
    filteredItems: Partial<RefinementListItem>[];
    resetSearch: () => void;
};

export function useSearchableFilterOptions(
    items: Partial<RefinementListItem>[],
    /** Only the stores facet opts into search; length gate still applies. */
    enabled = false
): UseSearchableFilterOptionsResult {
    const [searchQuery, setSearchQuery] = useState("");
    const isSearchable = enabled && items.length >= FILTER_SEARCH_MIN_ITEMS;

    const filteredItems = useMemo(() => {
        if (!isSearchable || !searchQuery.trim()) {
            return items;
        }

        const query = searchQuery.trim().toLowerCase();
        return items.filter((item) => item.label?.toLowerCase().includes(query));
    }, [items, isSearchable, searchQuery]);

    const resetSearch = () => setSearchQuery("");

    return {
        searchQuery,
        setSearchQuery,
        isSearchable,
        filteredItems,
        resetSearch,
    };
}
